/** @jsxImportSource @emotion/react */
import React from "react";
import { StyledText } from "../assets/typography/typography";
import { css } from "@emotion/react";
import { effects } from "./effects";
import { colors } from "./colors";
type Props = {} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

const wrapperStyle = css`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  padding: 16px;
  background-color: ${colors.white};
  border-radius: 8px;
  box-shadow: ${effects.cardRest};
  white-space: pre-wrap;
  height: fit-content;
`;

const verticalLineStyle = css`
  width: 4px;
  min-width: 4px;
  display: flex;
  align-items: center;
  align-self: stretch !important;
  background-color: ${colors.blueInteractive};
  border-radius: 9999px;
`;

export const InfoBanner = ({ children, ...props }: Props) => {
  return (
    <div css={wrapperStyle} {...props}>
      <div css={verticalLineStyle} />
      <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
        {children}
      </StyledText>
    </div>
  );
};
